import { useContext } from 'react';
import { css } from '@emotion/react';
import { useTheme } from '@emotion/react';
import { useMediaQuery } from '@dnhb/node_package';
import UserContext, { AUTH_STATUS } from '../../context/UserContext';
import Flex from './layouts/Flex';
import LoaderVault from 'imagesUwKluis/svg/loader_vault.svg';
import LoaderLock from 'imagesUwKluis/svg/loader_lock.svg';

const Loader = props => {
  const { breakpoints, colors } = useTheme();
  const isMinDesktop = useMediaQuery(
    `(min-width: ${breakpoints.ml ?? '56.25rem'})`
  );
  const { authStatus } = useContext(UserContext);

  return (
    <Flex
      justifyContent="center"
      alignItems="center"
      css={css`
        position: fixed;
        top: 0;
        right: 0;
        width: ${isMinDesktop && authStatus === AUTH_STATUS.loggedin && !props.fullWidth
          ? 'calc(100% - 272px)'
          : '100%'};
        height: 100%;
        background: rgba(255, 255, 255, 0.8);
        z-index: 100;
      `}
      {...props}
    >
      <div css={{ position: 'relative', width: '143px', height: '120px' }}>
        <LoaderVault width="143px" height="120px" fill={colors.loader} />
        <LoaderLock
          height="40px"
          fill={colors.loader}
          css={css`
            position: absolute;
            top: 44%;
            left: 16%;
            animation: spin 1.6s ease-in-out infinite;

            @keyframes spin {
              from {
                transform: rotate(0deg);
              }
              to {
                transform: rotate(360deg);
              }
            }
          `}
        />
      </div>
    </Flex>
  );
};

export default Loader;
